import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportProposalDetailPage } from './report-proposal-detail.page';

const routes: Routes = [
  {
    path: '',
    component: ReportProposalDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportProposalDetailPageRoutingModule {}
